<!--
  @Description 待办事项
  @Date 2021-12-22
  @Author liufu
-->
<template>
  <div class="container">
    <homeHeader title="待办事项"></homeHeader>
    <div class="main" v-show="isSearch">
      <div class="card">
        <!-- 查询面板 -->
        <!-- <div class="search-dv" v-if="searchFormVisible">
          <SearchForm ref="SearchForm"></SearchForm>
        </div> -->

        <!-- 按钮组 -->
        <div class="toolbar-dv">
          <toolBarBtn
            @changeSearchFormShow="changeSearchFormShow"
            :buttonVisible="buttonVisible"
            :parentData="this"
            ref="toolBarBtn"
          ></toolBarBtn>
        </div>

        <!-- 权限分配表格 -->
        <div class="approve-table-dv">
          <!-- 角色 -->
          <div class="left-role-dv" :style="{ height: this.approveCardHeight }">
            <div class="role-list-dv" :style="{ height: this.tableHeight }">
              <navList
                :listData="typeList"
                title="类型"
                :listKey="'name'"
                indexKey="name"
                :indexValue="indexValue"
                @itemClick="changeType"
              ></navList>
            </div>
          </div>
          <!-- 菜单明细 -->
          <div class="menu-dv" :style="{ height: this.approveCardHeight }">
            <div class="table-dv">
              <vxe-grid
                ref="xTable"
                resizable
                :column-config="{ minWidth: '80px' }"
                :data="tableData"
                size="mini"
                :cell-style="cellStyle"
                :mouse-config="{ area: true }"
                highlight-hover-row
                highlight-current-row
                :height="tableHeight"
                :columns="tableColumn"
                @cell-dblclick="handleDbClick"
                :menu-config="{
                  body: { options: bodyMenus },
                  visibleMethod: visibleMethod
                }"
                @menu-click="contextMenuClickEvent"
              >
              </vxe-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
    <YKToDoListDetail
      :parentData="this"
      v-if="!isSearch"
      :joinID="joinID"
      @SingleBack="SingleBack"
      ref="YKToDoListDetail"
    />
  </div>
</template>

<script>
// import NavigationList from './navList'
import YKToDoListDetail from './YKToDoListDetail.vue'
import { TEXT_COLOR_MAP } from '@/public/params/global.js'

export default {
  name: 'YKHoliday',
  components: {
    // NavigationList,
    YKToDoListDetail
  },
  data() {
    return {
      id: 0,
      searchFormVisible: false,
      tableColumn: [],
      // 正常状态下，需要加上表格距离card上下的margin
      topBottomMargin: 20,
      // 按钮组的可见性
      buttonVisible: {
        add: true, // 新增按钮是否显示
        update: false, // 修改按钮
        save: false, // 保存按钮是否显示
        delete: false, // 删除按钮是否显示
        refresh: true, // 刷新数据按钮是否显示
        lock: false, // 锁定按钮是否显示
        unlock: false, // 解锁按钮是否显示
        sort: false, // 排序按钮是否显示
        search: false, // 查找按钮是否显示
        more: false // 更多按钮是否显示
      },
      // 年份数据列表
      typeList: [{ name: '我发起的' }, { name: '全部' }, { name: '未完成' }, { name: '已完成' }],
      form: {},
      tableData: [],
      // 获取权限
      Authority: this.AuthorityFilter(this.$route.path),
      // 模态窗类型
      modalType: '',
      // 侧边栏默认所处的节点
      indexValue: '',
      // 是否为search界面
      isSearch: true,
      // 明细id
      joinID: 0,
      // 右键
      bodyMenus: [
        [
          {
            code: 'cancleMain',
            name: '取消待办'
          },
          {
            code: 'recoveryMain',
            name: '恢复待办'
          },
          {
            code: 'confirm',
            name: '确认完成'
          },
          {
            code: 'cancle',
            name: '取消确认完成'
          }
        ]
      ]
    }
  },
  mounted() {
    this.indexValue = this.todoDefaultShow
    this.list()
  },
  created() {
    this.InitColumn()
  },
  methods: {
    // 初始化
    InitColumn() {
      this.tableColumn = [
        { type: 'seq', width: 40 },
        {
          title: '主题',
          field: 'subject',
          filters: [{ data: null }],
          filterRender: { name: 'FilterInput' }
        },
        {
          title: '优先级',
          field: 'priorities',
          slots: {
            default: ({ row }) => {
              return [
                <el-tag size='small' type={this.colorPriorities(row.priorities)}>
                  {this.formatPriorities(row.priorities)}
                </el-tag>
              ]
            }
            // default: ({ row }) => {
            //   return [<span>{this.formatPriorities(row.priorities)}</span>]
            // }
          }
        },
        { title: '待办状态', field: 'status' },
        // { title: '我的处理状态', field: 'dStatus' },
        {
          field: 'dStatus',
          title: '我的处理状态'
          // slots: {
          //   default: ({ row }) => {
          //     return [<span>{this.formatMyState(row)}</span>]
          //   }
          // }
        },
        {
          title: '要求完成日期',
          field: 'dueDate',
          formatter: ['formatDate', 'yyyy-MM-dd']
        },
        { title: '发起人', field: 'writer' },
        {
          title: '发起日期',
          formatter: ['formatDate', 'yyyy-MM-dd'],
          field: 'writeDate'
        }
      ]
    },
    // 切换查询面板可见性
    changeSearchFormShow() {
      this.searchFormVisible = !this.searchFormVisible
    },
    changeType(item) {
      this.indexValue = item.name
      this.list()
    },
    // 我的处理状态过滤
    // formatMyState(item) {
    //   if (item.personID === this.$store.state.userInfo.userId) {
    //     return item.dStatus
    //   } else {
    //     return '/'
    //   }
    // },
    // 右键控制菜单方法
    visibleMethod({ options, column, row }) {
      // 显示之前处理按钮的操作权限
      options.forEach(list => {
        list.forEach(item => {
          item.visible = false
          if (column) {
            if (row.status !== '取消' && row.dStatus === '未完成' && item.code === 'confirm') {
              item.visible = true
            } else if (row.status !== '取消' && row.dStatus === '已完成' && item.code === 'cancle') {
              item.visible = true
            } else if (row.status !== '取消' && row.dStatus === '/' && item.code === 'cancleMain') {
              item.visible = true
            } else if (row.status === '取消' && row.dStatus === '/' && item.code === 'recoveryMain') {
              item.visible = true
            } else {
              item.visible = false
            }
          }
        })
      })
      return true
    },
    // 右键确认
    contextMenuClickEvent({ menu, row }) {
      switch (menu.code) {
        case 'confirm':
          this.confirmOrCancle(row.id, '完成')
          break
        case 'cancle':
          this.confirmOrCancle(row.id, '取消完成')
          break
        case 'cancleMain':
          this.cancleOrRecoveryMain(row.id, '取消')
          break
        case 'recoveryMain':
          this.cancleOrRecoveryMain(row.id, '恢复')
          break
      }
    },
    // 取消完成或确认完成待办
    async confirmOrCancle(id, type) {
      const { data: res } = await this.$http.put('/Common/YKToDoList/confirmOrCancle', {
        id: id,
        type: type
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success('操作成功!')
      this.list()
    },
    // 取消或恢复待办
    async cancleOrRecoveryMain(id, type) {
      const { data: res } = await this.$http.put('/Common/YKToDoList/cancleOrRecovery', {
        id: id,
        type: type
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success('操作成功!')
      this.list()
    },
    // 新增
    add() {
      if (!this.Authority.edit) {
        this.$message.error('您没有相关权限！')
        return
      }
      this.joinID = 0
      this.$nextTick(() => {
        this.isSearch = false
      })
    },
    // 刷新数据
    refresh() {
      if (!this.Authority.see) {
        this.$message.error('您没有查看权限')
        return
      }
      this.list()
    },
    // 获取数据
    async list() {
      if (!this.Authority.see) {
        this.$message.error('您没有查看权限')
        return
      }
      const { data: res } = await this.$http.get('/Common/YKToDoList/list', {
        params: {
          type: this.indexValue
        }
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.tableData = res.data.rows

      // 2022-02-28 （暂时弃用）若默认树节点无数据，则跳转到类型为 [全部] 的树节点
      // if (type === 'one') {
      //   if (!res.data.rows.length) {
      //     this.indexValue = '全部'
      //     this.list()
      //   } else {
      // this.tableData = res.data.rows
      //   }
      // } else {
      //   this.tableData = res.data.rows
      // }
      // this.fullTableData = res.data.rows
      // this.changeData(this.indexValue)
    },
    // 修改模态窗类型
    updateModalType(Str) {
      this.modalType = Str
    },
    SingleBack() {
      // id
      this.isSearch = true
      // if (!id || id === 0) {
      //   return
      // }
      // if (id < 0) {
      this.list()
      // }
    },
    // 双击查看明细数据
    handleDbClick({ row }) {
      this.$refs.xTable.closeTooltip()
      this.joinID = row.id
      this.$nextTick(() => {
        this.isSearch = false
      })
    },
    // 优先级tag类型，返回值：[success/info/danger]
    colorPriorities(value) {
      if (Number(value) === 1) {
        // 紧急
        return 'danger'
      } else if (Number(value) === 2) {
        // 普通
        return 'default'
      } else {
        // 不急
        return 'info'
      }
    },
    cellStyle({ column, row }) {
      // 优先级
      if (column.property === 'priorities') {
        return this.setPrioritiesColor(row['priorities'])
      }
      // 整行的状态：1.未解决 [超期、未超期]  2.解决 [超期、未超期]  3.取消
      return this.setRowColor(row, column)

      // 待办状态
      // if (column.property === 'status') {
      //   return this.setStatusColor(row['status'])
      // }
      // // 要求完成日期
      // if (column.property === 'dueDate') {
      //   const STUTA = this.checkIsOutTime(row[column.property], 3)
      //   return this.setDueDateColor(STUTA, row['status'])
      // }
    },
    setRowColor(row, column) {
      if (['status', 'dueDate'].includes(column.property)) {
        if (row['status'] === '已完成') {
          return {
            color: TEXT_COLOR_MAP['GREEN']
          }
        } else if (row['status'] === '取消') {
          return {
            color: TEXT_COLOR_MAP['GREY']
          }
        } else if (row['status'] === '未完成') {
          // 临近
          if (this.checkIsNearTime(row['dueDate'], 3)) {
            return {
              color: TEXT_COLOR_MAP['YELLOW']
            }
          } else {
            // 非临近
            return {
              color: TEXT_COLOR_MAP['RED']
            }
          }
        }
      }
    },
    // [优先级]颜色设置
    setPrioritiesColor(value) {
      const PRIO = {
        1: '紧急',
        2: '普通',
        3: '不急'
      }

      // 紧急为红色（1），普通为黑色（2），不急为灰色（3）
      if (PRIO[Number(value)] === '紧急') {
        return {
          color: TEXT_COLOR_MAP['RED']
        }
      } else if (PRIO[Number(value)] === '不急') {
        return {
          color: TEXT_COLOR_MAP['GREY']
        }
      }
    },
    // [待办状态]颜色设置
    setStatusColor(value) {
      // 未完成为红色，已完成为绿色
      if (value === '未完成') {
        return {
          color: TEXT_COLOR_MAP['RED']
        }
      } else if (value === '已完成') {
        return {
          color: TEXT_COLOR_MAP['GREEN']
        }
      } else {
        // [取消] 状态
        return {
          color: TEXT_COLOR_MAP['GREY']
        }
      }
    },
    //
    /**
     * [要求完成日期]颜色设置
     * @param {Number} value 是否超期的状态
     * @param {String} todoStatu 待办状态
     */
    setDueDateColor(value, todoStatu) {
      // value [1:超期  2:临近  3:未临近且未超期]
      // 近3天显示为黄色，超期（日期超出且待办状态为未完成）显示为红色
      if (value === 1 && todoStatu === '未完成') {
        return {
          color: TEXT_COLOR_MAP['RED']
        }
      } else if (value === 2) {
        return {
          color: TEXT_COLOR_MAP['YELLOW']
        }
      }
    },
    /**
     * 是否超期，若未超期则判断是否距离完成日期还有x天
     * @param {String} targetDate 用于比较的日期
     * @param {Number} days 提前x天
     */
    // checkIsOutTime (targetDate, days) {
    //   // 超期
    //   const OUT_TIME = 1
    //   // 临近
    //   const NEAR_TIME = 2
    //   // 未超期，未临近
    //   const UN_NEAR_TIME = 3

    //   const curDateTime = new Date(this.ykDateFormat('yyyy-MM-dd', new Date())).getTime()
    //   const targetDateTime = new Date(this.ykDateFormat('yyyy-MM-dd', targetDate)).getTime()

    //   // 1.超期
    //   if (curDateTime > targetDateTime) return OUT_TIME

    //   // 2.未超期，判断是否距离完成日期还有x天
    //   const day = 86400 * 1000
    //   // 如：目标日期 2022-01-05，今天日期 2022-01-01，提前3天为临近，则该日期为 [未临近]
    //   const diffDay = (targetDateTime - curDateTime) / day
    //   if (diffDay <= days) {
    //     return NEAR_TIME
    //   }

    //   // 3.未超期，也未临近完成日期
    //   return UN_NEAR_TIME
    // },
    /**
     * 是否超期，若未超期则判断是否距离完成日期还有x天
     * @param {String} targetDate 用于比较的日期
     * @param {Number} days 提前x天
     */
    checkIsNearTime(targetDate, days) {
      // 超期
      const OUT_TIME = false
      // 临近
      const NEAR_TIME = true
      // 未临近
      const UN_NEAR_TIME = false

      const curDateTime = new Date(this.ykDateFormat('yyyy-MM-dd', new Date())).getTime()
      const targetDateTime = new Date(this.ykDateFormat('yyyy-MM-dd', targetDate)).getTime()

      // 超期，直接返回false
      if (curDateTime > targetDateTime) return OUT_TIME

      // 1.未超期，判断是否距离完成日期还有x天
      const day = 86400 * 1000
      // 如：目标日期 2022-01-05，今天日期 2022-01-01，提前3天为临近，则该日期为 [未临近]
      const diffDay = (targetDateTime - curDateTime) / day
      if (diffDay <= days) {
        return NEAR_TIME
      }

      // 2.未超期，也未临近完成日期
      return UN_NEAR_TIME
    },
    formatPriorities(num) {
      switch (Number(num)) {
        case 1:
          return '紧急'
        case 2:
          return '普通'
        case 3:
          return '不急'
      }
    }
  },
  computed: {
    tableHeight() {
      let isSearchForm = this.searchFormVisible
      let isToolBar = true

      // 若有查询框，则共有四段 margin; 否则只有表格的两段 margin
      let tableMargin = isSearchForm ? this.heightConfig.mainMargin * 4 : this.heightConfig.mainMargin * 2
      return this.tableHeightComputed(tableMargin + this.topBottomMargin, isSearchForm, isToolBar)
    },
    // 表格容器高度，需加上margin边距
    approveCardHeight() {
      return this.tableHeight + this.topBottomMargin
    },
    // 首次进入时默认查看的节点，默认值 '未完成'
    todoDefaultShow() {
      return this.$store.state.systemSetting.todoDefaultShow || '未完成'
    }
  }
}
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  margin: 0 auto;
  height: calc(100vh - @header-height);
  overflow: hidden;
}
.card {
  margin: @main-margin;
  box-shadow: #bebebe 2px 2px 10px;
  border-radius: 10px;
  overflow: hidden;
}
.search-dv {
  background-color: aquamarine;
  height: 100px;
  margin: @main-margin 10px;
}

.toolbar-dv {
  padding: 10px;
}

.table-dv {
  padding: @topBottomMargin;
}

.approve-table-dv {
  display: flex;
}
// 角色名称列表
.left-role-dv {
  width: 15%;
  padding: 10px;
}
.role-list-dv {
  width: 100%;
  border-radius: 5px;
  box-shadow: #e2e2e2 0px 0px 3px;
  border: 1px solid #eeeeee;
  overflow: hidden;
  position: relative;
}

// 权限菜单列表
.menu-dv {
  width: 85%;
}

.vxe-checkbox {
  width: 15px !important;
}
</style>
